import axios from 'axios';

export default {
  get: (params) => axios.get('/api/v1/company', { params }),
  getById: (id) => axios.get(`/api/v1/company/${id}`),
  create: (params) => axios.post('/api/v1/company', params, { headers: { 'Content-Type': 'multipart/form-data' } }),
  update: (params, id) => axios.put(`/api/v1/company/${id}`, params, { headers: { 'Content-Type': 'multipart/form-data' } }),
  delete: (params) => axios.delete('/api/v1/company', { params }),
};
